import * as constAction from 'root/actionConstants';
import { Map, List, fromJS } from 'immutable';
import { listFindByMapId } from 'core/generalFunctions';

var defaultState = Map({
  lista: List(),
  trayecto: null,
  paradas: List(),
  tasks: List(),
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.TRAYECTOS_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload)) return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.TRAYECTOS_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    case constAction.TRAYECTOS_DELETE_STATE: {
      let index = listFindByMapId(state.get('lista'), action.payload, true);
      return state.deleteIn(['lista', index]);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/modules/trayectos/reducer.js